/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrComboBoxColumn } from './igr-combo-box-column';
import { ComboBoxColumn } from './ComboBoxColumn';
import { TypeRegistrar } from "igniteui-react-core";
var IgrComboBoxColumnModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrComboBoxColumnModule() {
    }
    IgrComboBoxColumnModule.register = function () {
        TypeRegistrar.registerCons("IgrComboBoxColumn", IgrComboBoxColumn);
        TypeRegistrar.register("ComboBoxColumn", ComboBoxColumn.$type);
    };
    return IgrComboBoxColumnModule;
}());
export { IgrComboBoxColumnModule };
//# sourceMappingURL=igr-combo-box-column-module.js.map
